import { render } from "./EditClientPage.vue?vue&type=template&id=7424476a&ts=true"
import script from "./EditClientPage.vue?vue&type=script&lang=ts"
export * from "./EditClientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__